import _toConsumableArray from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import StandardTableVue from '@/components/table/StandardTable.vue';
import { Empty } from 'ant-design-vue';
import { getErpList, getSellerList, getBusFormat, getOnlyIdAndNameList, getPayersList } from '@/services/customer/erpCustomerList';
import { getInclude, deleteInclude } from './utils';
import { getErpGroupList } from '@/services/customer/erpGrouped';
export default {
  components: {
    StandardTableVue: StandardTableVue
  },
  i18n: require("@/pages/dyxmanager/dyxDisGroup/i18n-dyx"),
  props: {
    alreadySelect: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var _this = this;
    var h = this.$createElement;
    var columns = [{
      dataIndex: 'erpCustomerCode',
      title: this.$t('account.dyxNumber')
    }, {
      title: this.$t('account.dyxName'),
      dataIndex: 'erpCustomerName'
    }, {
      title: this.$t('account.yetai'),
      dataIndex: 'busFormatName'
    }, {
      title: this.$t('account.qqx'),
      dataIndex: 'payerName'
    }, {
      title: this.$t('account.ddz'),
      dataIndex: 'sellerName'
    }];
    return {
      labelCol: {
        span: 9
      },
      wrapperCol: {
        span: 15
      },
      columns: columns,
      queryLoading: false,
      btnLoading: false,
      ddzList: [],
      ytList: [],
      dyxGroupedList: [],
      addressList: [],
      qqxList: [],
      queryParam: {
        dyxContent: '',
        dudaofuxian: undefined,
        ddz: undefined,
        yt: undefined,
        qingqiuxian: undefined,
        dyxCalssify: [],
        dyxEndNumber: '',
        dyxStartNumber: ''
      },
      loadingTable: false,
      pagination: {
        pageSizeOptions: ['5', '10', '20'],
        total: 0,
        showTotal: function showTotal(total, r) {
          return "".concat(_this.$t('account.total2')).concat(total);
        },
        pageSize: 5,
        current: 1,
        showSizeChanger: true,
        'show-quick-jumper': true
      },
      data: [],
      selectedRowKeys: [],
      indeterminate: false,
      checkAll: false,
      locale: {
        emptyText: h("a-empty", {
          "attrs": {
            "image": Empty.PRESENTED_IMAGE_SIMPLE
          }
        }, [" ", h("span", {
          "slot": "description"
        }, [" ", this.$t('account.emptyDyxTip'), " "]), "  "])
      },
      visible: false,
      total: 0,
      selectedData: [],
      optionIdList: [],
      copyQueryparam: {},
      allErpCustomerIds: []
    };
  },
  mounted: function mounted() {},
  computed: {
    rowSelection: function rowSelection() {
      var _this2 = this;
      return {
        onChange: function onChange(selectedRowKeys, selectedRows) {
          // this.$emit('getTotal', selectedRowKeys.length,selectedRows)
          _this2.selectedRowKeys = selectedRowKeys;
          // this.indeterminate = !! this.selectedRowKeys.length &&  this.selectedRowKeys.length < this.data.length
          // this.checkAll = this.selectedRowKeys.length === this.data.length
          // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
        },
        selectedRowKeys: this.selectedRowKeys
      };
    }
  },
  watch: {
    visible: function visible(newVal, oldVal) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var params1, res1, res2, params, res, res3, res4;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!newVal) {
                _context.n = 6;
                break;
              }
              _this3.selectedRowKeys = _this3.alreadySelect;
              // 获取担当者列表
              params1 = {
                type: 1
              };
              _context.n = 1;
              return getSellerList(params1);
            case 1:
              res1 = _context.v;
              if (res1.data.code == 200) {
                _this3.ddzList = res1.data.data.map(function (item) {
                  return {
                    value: item.sellerCode,
                    name: item.sellerName
                  };
                });
              }
              // 获取业态列表
              _context.n = 2;
              return getBusFormat();
            case 2:
              res2 = _context.v;
              console.log(res2);
              if (res2.data.code == 200) {
                _this3.ytList = res2.data.data.map(function (item) {
                  return {
                    value: item.busFormatCode,
                    name: item.busFormatName
                  };
                });
              }
              // 得意先分组
              params = {
                sence: 2
              };
              _context.n = 3;
              return getErpGroupList(params);
            case 3:
              res = _context.v;
              if (res.data.code == 200) {
                _this3.dyxGroupedList = res.data.data.list.map(function (item) {
                  return {
                    value: item.groupId,
                    name: item.groupName
                  };
                });
              }
              // 都道府县
              _context.n = 4;
              return getOnlyIdAndNameList();
            case 4:
              res3 = _context.v;
              console.log(res3, '3333');
              if (res3.data.code == 200) {
                _this3.addressList = res3.data.data[0].regionList.map(function (item) {
                  return {
                    value: item.id,
                    name: item.title
                  };
                });
              }
              // 请求先
              _context.n = 5;
              return getPayersList();
            case 5:
              res4 = _context.v;
              if (res4.data.code == 200) {
                _this3.qqxList = res4.data.data.map(function (item) {
                  return {
                    value: item.payerCode,
                    name: item.payerName
                  };
                });
              }
            case 6:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    selectedRowKeys: function selectedRowKeys(newVal, oldVal) {
      this.getState(newVal, this.allErpCustomerIds);
      this.total = this.selectedRowKeys.length;
    }
  },
  methods: {
    initData: function initData(info, query) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var h, params, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              h = _this4.$createElement;
              _this4.loadingTable = true;
              _context2.p = 1;
              params = _this4.getParams(query);
              _context2.n = 2;
              return getErpList(params);
            case 2:
              res = _context2.v;
              if (res.data.code == 200) {
                _this4.data = res.data.data.list;
                _this4.pagination.total = res.data.data.total;
                _this4.allErpCustomerIds = res.data.data.allErpCustomerIds;
                if (_this4.data.length == 0) {
                  _this4.locale = {
                    emptyText: h("a-empty", {
                      "attrs": {
                        "image": Empty.PRESENTED_IMAGE_SIMPLE
                      }
                    }, [" ", h("span", {
                      "slot": "description"
                    }, [" ", _this4.$t('account.noDyx'), " "]), "  "])
                  };
                }
                // 说明点的是全部也全部选 
                if (info) {
                  console.log(1111);
                  if (getInclude(_this4.selectedRowKeys, _this4.allErpCustomerIds) == 3) {
                    _this4.checkAll = false;
                    _this4.indeterminate = false;
                    _this4.selectedRowKeys = deleteInclude(_this4.selectedRowKeys, _this4.allErpCustomerIds);
                    console.log(_this4.selectedRowKeys, 'selectRows');
                  } else {
                    _this4.checkAll = true;
                    _this4.indeterminate = false;
                    _this4.selectedRowKeys = Array.from(new Set([].concat(_toConsumableArray(_this4.allErpCustomerIds), _toConsumableArray(_this4.selectedRowKeys))));
                    console.log(_this4.selectedRowKeys, 'selectRows22');
                  }
                } else {
                  _this4.getState(_this4.selectedRowKeys, _this4.allErpCustomerIds);
                }
                _this4.total = _this4.selectedRowKeys.length;
              }
            case 3:
              _context2.p = 3;
              _this4.queryLoading = false;
              _this4.loadingTable = false;
              return _context2.f(3);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, null, [[1,, 3, 4]]);
      }))();
    },
    getState: function getState(arr1, arr2) {
      // 一开始搜索5个 全部选了 又搜索了10个  应该改为半选
      if (getInclude(arr1, arr2) == 2) {
        this.checkAll = false;
        this.indeterminate = true;
      }
      // 选择了5个 又搜索了没有 应该把全部选置为空
      if (getInclude(arr1, arr2) == 1) {
        this.checkAll = false;
        this.indeterminate = false;
      }
      // 选择了5个 又搜索了包含所有的 应该把全部选置为true
      if (getInclude(arr1, arr2) == 3) {
        this.checkAll = true;
        this.indeterminate = false;
      }
    },
    queryProductList: function queryProductList() {
      // 查询的时候加上按钮的Loading 防止连续点击
      this.queryLoading = true;
      this.initData(false, true);
    },
    getParams: function getParams(query) {
      var params = {
        erpCustomerCodeStart: this.queryParam.dyxStartNumber,
        erpCustomerCodeEnd: this.queryParam.dyxEndNumber,
        erpCustomerInfo: this.queryParam.dyxContent,
        sellerCode: this.queryParam.ddz ? this.queryParam.ddz.join(',') : this.queryParam.ddz,
        busFormatCode: this.queryParam.yt,
        payerInfo: this.queryParam.qingqiuxian,
        // 还差一个得意先分组 和都道夫县
        customerGroupIdList: this.queryParam.dyxCalssify,
        // 类型： 弹窗
        provinceId: this.queryParam.dudaofuxian,
        scene: 2,
        // 是否返回检索的所有得意先id集合
        needAllErpCustomerIds: true,
        page: 1,
        size: this.pagination.pageSize
      };
      if (query) {
        params.page = 1;
        this.pagination.current = 1;
      } else {
        params.page = this.pagination.current;
      }
      return params;
    },
    changePage: function changePage(e) {
      this.pagination.current = e.current;
      this.pagination.pageSize = e.pageSize;
      this.initData(false, false);
    },
    showSizeChange: function showSizeChange(e) {
      this.pagination.current = e.current;
      this.pagination.pageSize = e.pageSize;
      this.initData(false, false);
    },
    selectAll: function selectAll() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this5.initData(true, false);
              console.log(_this5.data, 'data');
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    handleOk: function handleOk() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var params, res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!(_this6.selectedRowKeys.length > 0)) {
                _context4.n = 5;
                break;
              }
              params = {
                erpCustomerIdsStr: _this6.selectedRowKeys
              };
              _this6.btnLoading = true;
              _context4.p = 1;
              _context4.n = 2;
              return getErpList(params);
            case 2:
              res = _context4.v;
              if (res.data.code == 200) {
                console.log(res, '...res....');
                _this6.selectedData = res.data.data.list;
                _this6.$emit('confirmProduct', _this6.selectedData);
              }
            case 3:
              _context4.p = 3;
              _this6.btnLoading = false;
              _this6.resetAll();
              _this6.visible = false;
              return _context4.f(3);
            case 4:
              _context4.n = 6;
              break;
            case 5:
              _this6.selectedData = [];
              _this6.$emit('confirmProduct', _this6.selectedData);
              _this6.resetAll();
              _this6.visible = false;
            case 6:
              return _context4.a(2);
          }
        }, _callee4, null, [[1,, 3, 4]]);
      }))();
    },
    handleCancel: function handleCancel() {
      this.resetAll();
      this.visible = false;
    },
    resetAll: function resetAll() {
      var h = this.$createElement;
      this.queryParam = {};
      this.selectedRowKeys = [];
      this.data = [];
      this.pagination.total = 0;
      this.locale = {
        emptyText: h("a-empty", {
          "attrs": {
            "image": Empty.PRESENTED_IMAGE_SIMPLE
          }
        }, [" ", h("span", {
          "slot": "description"
        }, [" ", this.$t('account.emptyDyxTip'), " "]), "  "])
      };
      this.total = 0;
    }
  }
};